import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionPanelComponent } from './auction-panel.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule, IfItemEnabled } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [AuctionPanelComponent],
  imports: [
    CommonModule,
    PipesModule,
    CountdownModule,
    LoyaltyIconModule,
    DirectivesModule,
    RouterModule,
    IfItemEnabled,
    FGBSharedModule,
    CarouselModule,
  ],
  exports: [AuctionPanelComponent],
})
export class AuctionPanelModule {}
